import { Gamepad2 } from "lucide-react";

const CARDS = [
  { title: "Video Game Consoles", category: "Consoles", image: "/assets/product-02.webp" },
  { title: "EDC Toys", category: "EDC Toys", image: "/assets/cat-edc.jpg" },
  { title: "Collectibles", category: "Collectibles", image: "/assets/cat-collectibles.png" },
  { title: "Model Kits & Building Sets", category: "Model Kits & Building Sets", image: "/assets/product-09.webp" },
];

export default function Interests({ onSelect }) {
  return (
    <section className="py-20 md:py-28 bg-[#f7f5f1]" data-testid="interests-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-[#0d7a72] text-sm font-bold tracking-[0.25em] uppercase mb-3">Browse</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#10233f] mb-4" data-testid="interests-heading">
          Find Your Interest
        </h2>
        <p className="text-base text-[#5a6b85] max-w-2xl mb-12">
          Choose a category to explore the matching products below.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {CARDS.map((c) => (
            <button
              key={c.category}
              onClick={() => onSelect(c.category)}
              data-testid={`interest-card-${c.category.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group text-left"
            >
              <div className="aspect-[4/3] rounded-2xl bg-white border border-[#e6e1d8] overflow-hidden img-zoom card-lift flex items-center justify-center p-4">
                {c.image ? (
                  <img src={c.image} alt={c.title} className="w-full h-full object-contain" />
                ) : (
                  <div className="flex flex-col items-center gap-3 text-[#10233f]/40" data-testid="interest-card-consoles-placeholder">
                    <Gamepad2 className="w-14 h-14" strokeWidth={1.2} />
                    <span className="text-xs font-semibold tracking-widest uppercase">Photo coming soon</span>
                  </div>
                )}
              </div>
              <h3 className="mt-4 text-base md:text-lg font-bold text-[#10233f] group-hover:text-[#0d7a72] transition-colors">
                {c.title}
              </h3>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
